import React from 'react';
import { Badge, Tooltip } from 'antd';
import { WifiOutlined, LoadingOutlined, DisconnectOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import useWebSocketStatus from '../hooks/useWebSocketStatus';
import { useConnection } from '../ConnectionContext';

const ConnectionStatus = () => {
  const { connectionState } = useWebSocketStatus();
  const { isOnline, latency } = useConnection();

  const getStatusIcon = () => {
    if (!isOnline) {
      return <DisconnectOutlined style={{ color: '#ff4d4f' }} />;
    }

    switch (connectionState) {
      case 'connected':
        return <WifiOutlined style={{ color: '#52c41a' }} />;
      case 'connecting':
        return <LoadingOutlined style={{ color: '#faad14' }} />;
      case 'disconnected':
        return <DisconnectOutlined style={{ color: '#ff4d4f' }} />;
      case 'error':
        return <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />;
      default:
        return <WifiOutlined style={{ color: '#bfbfbf' }} />;
    }
  };

  const getStatusText = () => {
    if (!isOnline) {
      return 'Sin conexión a Internet';
    }

    switch (connectionState) {
      case 'connected':
        if (latency === 9999) {
          return 'WebSocket conectado - API con problemas';
        }
        return `Conectado${latency && latency !== 9999 ? ` (${latency}ms)` : ''}`;
      case 'connecting':
        return 'Conectando...';
      case 'disconnected':
        return 'Desconectado';
      case 'error':
        return 'Error de conexión';
      default:
        return 'Desconocido';
    }
  };

  const getStatusColor = () => {
    if (!isOnline || connectionState === 'disconnected' || connectionState === 'error') {
      return 'error';
    }
    if (connectionState === 'connecting') {
      return 'warning';
    }
    if (connectionState === 'connected') {
      // Si hay problemas de API pero WebSocket conectado, mostrar warning
      if (latency === 9999) {
        return 'warning';
      }
      return 'success';
    }
    return 'default';
  };

  return (
    <Tooltip title={getStatusText()}>
      <Badge 
        status={getStatusColor()} 
        dot
        style={{ marginRight: 8 }}
      >
        {getStatusIcon()}
      </Badge>
    </Tooltip>
  );
};

export default ConnectionStatus;